import { create } from "zustand"
import { DEFAULT_LOCALE, type AppLocale } from "../i18n"

type LocaleState = {
  locale: AppLocale
  setLocale: (locale: AppLocale) => void
}

export const useLocaleStore = create<LocaleState>((set) => ({
  locale: DEFAULT_LOCALE,
  setLocale: (locale) => set({ locale }),
}))
